import { render } from "./CardOk.vue?vue&type=template&id=1ff2258b&lang=pug"
import script from "./CardOk.vue?vue&type=script&lang=js"
export * from "./CardOk.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__